<!-- Icon above the node -->
<div
  class="type-icon arrow-in"
  *ngIf="icon"
  [ngClass]="{
    'type-icon-with-name': !!step?.name,
    'type-icon-without-name': !step?.name,
    enabled: enabled,
  }"
  [ngStyle]="{
    background: (hasError$ | async) ? ERROR_ICON_COLOR : (hasWarning$ | async) ? WARNING_ICON_COLOR : iconColor,
  }"
>
  <ng-container *ngIf="isCustomIcon(icon); else defaultIconTemplate">
    <mat-icon [svgIcon]="icon"></mat-icon>
  </ng-container>
  <ng-template #defaultIconTemplate>
    <mat-icon>{{ icon }}</mat-icon>
  </ng-template>
</div>

<!-- Automation node -->
<mat-card
  appearance="outlined"
  #card
  class="automation-node-item {{ this.type }}"
  [ngClass]="{
    'arrow-in': type !== 'task',
    'error-node': (hasError$ | async),
    'warning-node': (hasWarning$ | async),
    enabled: enabled,
    selected: selected,
    border: isGrouped(),
  }"
>
  <mat-card-header
    class="card-header"
    [ngStyle]="{
      background: (hasError$ | async) ? ERROR_ICON_COLOR : (hasWarning$ | async) ? WARNING_ICON_COLOR : iconColor,
    }"
  >
    @if (step?.id !== 'trigger' && nodeActionsService.grouping() && isGroupable()) {
      <mat-checkbox
        class="group-checkbox"
        [checked]="isGrouped()"
        (change)="groupClicked($event)"
        (click)="$event.stopPropagation()"
        [disabled]="!isUnGroupable()"
        data-action="step-group-checkbox-clicked"
      >
      </mat-checkbox>
    }
    <span class="automation-node-name">
      {{ step?.name }}
    </span>
    <div class="card-header-inner-right">
      <span class="automation-node-name internal-node" *ngIf="isInternal$ | async">
        {{ 'AUTOMATIONS.COMMON.INTERNAL' | translate }}
      </span>

      <mat-icon
        *ngIf="step?.notes"
        glxyTooltip="View notes"
        [glxyPopover]="notePopover"
        (click)="notePopover.open(); $event.stopPropagation()"
      >
        comment
      </mat-icon>

      <ng-container *ngIf="isDeleting === false; else menuWorkingTemplate">
        <mat-icon
          *ngIf="
            type !== 'trigger' &&
            enabled &&
            !automation?.isDefaultAutomation &&
            automation?.runningState === runningStates.RUNNING_STATE_STOPPED
          "
          [matMenuTriggerFor]="menu"
          (click)="$event.stopPropagation()"
          class="menu-icon"
        >
          more_vert
        </mat-icon>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="copyClicked()">{{ 'COMMON.ACTION_LABELS.COPY' | translate }}</button>
          <div
            [glxyTooltip]="groupButtonToolTip"
            [tooltipPositions]="tooltipPositions"
            [glxyTooltipDisabled]="!groupButtonDisabled"
          >
            <button
              mat-menu-item
              (click)="groupClicked({ checked: true })"
              [disabled]="groupButtonDisabled"
              data-action="step-menu-group-clicked"
            >
              {{ 'COMMON.ACTION_LABELS.GROUP' | translate }}
            </button>
          </div>
          <div
            [glxyTooltip]="deleteButtonToolTip"
            [tooltipPositions]="tooltipPositions"
            [glxyTooltipDisabled]="!deleteButtonDisabled"
          >
            <button mat-menu-item [disabled]="deleteButtonDisabled" (click)="deleteClicked()">
              {{ 'COMMON.ACTION_LABELS.DELETE' | translate }}
            </button>
          </div>
        </mat-menu>
      </ng-container>
      <ng-template #menuWorkingTemplate>
        <glxy-loading-spinner class="menu-loading-spinner" [inline]="true"></glxy-loading-spinner>
      </ng-template>
    </div>
  </mat-card-header>
  <mat-card-content>
    <div
      class="automation-node-content-container-standard new-restricted-content-height"
      [ngClass]="{
        'action-without-conditions':
          (step?.choices?.rules?.length || 0) <= 1 && type !== 'trigger' && (filters?.length || 0) === 0,
        'trigger-without-filters': type === 'trigger' && displayContents$?.length === 0,
      }"
      (click)="contentClicked.emit()"
    >
      <div
        class="trigger-and-action-panel-summary"
        [ngClass]="{ 'trigger-panel-summary new-restricted-content-height': type === 'trigger' }"
      >
        <ng-content select="automata-automation-node-content"></ng-content>
      </div>
      <div *ngIf="displayContents$?.length > 0">
        <span class="operator">
          {{ 'AUTOMATIONS.EDITOR.FILTERS.COMPARISON.AND' | translate }}
        </span>
        <ng-container *ngFor="let displayContent$ of displayContents$; let first = first">
          <span *ngIf="!first" class="operator">
            {{ 'AUTOMATIONS.EDITOR.FILTERS.COMPARISON.AND' | translate }}
          </span>
          <div class="filter-nodes-outer">
            <div class="filter-nodes-inner new-restricted-content-height" [innerHTML]="displayContent$ | async"></div>
          </div>
        </ng-container>
      </div>
    </div>
    <ng-container *ngIf="!isAutomationStopped() && this.stepHasSleep">
      <div class="currently-waiting-container">
        <a
          *ngIf="numberWaiting$ | async as numWaiting"
          (click)="openCurrentlyWaitingDialog($event)"
          [innerHTML]="
            'AUTOMATIONS.EDITOR.CURRENTLY_WAITING.NODE_LABEL' | translate: { numWaiting: numWaiting } | iTrustThisHtml
          "
        ></a>
      </div>
    </ng-container>
    <button mat-stroked-button class="go-to-step-button" *ngIf="showGoToAction" (click)="jumpToStepAction($event)">
      {{ 'AUTOMATIONS.EDITOR.TASKS.JUMP.GO_TO_ACTION' | translate }}
    </button>
  </mat-card-content>
  <mat-card-footer *ngIf="showDebugInfo$ | async">
    <mat-accordion>
      <mat-expansion-panel #panel [style]="panel.expanded ? 'position:relative; z-index:10;' : ''">
        <mat-expansion-panel-header>
          <mat-panel-title> StepID: {{ step?.id }}</mat-panel-title>
        </mat-expansion-panel-header>
        <div style="width:100%; height100%; overflow-x:scroll;">
          <div>TaskDefinitionID: {{ step?.taskDefinitionId }}</div>
          <pre>Choices: {{ step?.choices | json }}</pre>
          <div>Data: {{ step?.data | json }}</div>
          <ng-container *ngIf="step?.waitForTriggerTaskDefinitionId">
            <div>WaitingTrigger: {{ step?.waitForTriggerDefinitionId }}</div>
            <pre>{{ step?.waitForTriggerFilter | json }}</pre>
          </ng-container>
          <ng-container *ngIf="step?.customOutputParameters?.length > 0">
            <div>Custom Output Parameters:</div>
            <pre>{{ step?.customOutputParameters | json }}</pre>
          </ng-container>
          <ng-container>
            <div>Preceding steps:</div>
            <pre>{{ precedingSteps | json }}</pre>
          </ng-container>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-footer>
</mat-card>

<!-- Note hover -->
<glxy-popover #notePopover closeOnBackdropClick="true" keepOnScreen="true">
  <glxy-popover-title>{{ 'AUTOMATIONS.EDITOR.NOTE_POPOVER.TITLE' | translate }}</glxy-popover-title>
  <div class="notes-content">{{ step?.notes }}</div>
  <glxy-popover-actions>
    <button
      mat-stroked-button
      *ngIf="enabled && automation?.runningState === runningStates.RUNNING_STATE_STOPPED"
      (click)="contentClicked.emit(); notePopover.close()"
    >
      {{ 'AUTOMATIONS.EDITOR.NOTE_POPOVER.EDIT' | translate }}
    </button>
  </glxy-popover-actions>
</glxy-popover>

<!-- Drag handles can not be inside components. Have to put drag handles in component inputs/slots -->
<!-- https://github.com/angular/components/pull/13360#issuecomment-463137794 -->
